
import axios from "axios";
import { stringify } from "qs";
import { showFormAlert } from '../../general/form-ajax-alert';
import { formParams } from '../../general/form-ajax-post';
import { handleFormSubmit, toggleFormInputs, validationEventListener } from '../../general/form-validation'
import { cloudflare_turnstile } from "../../integration/turnstile";
import Alpine from 'alpinejs'

const bsn = require('bootstrap.native');
const url = new URL(document.URL);
const h1 = document.getElementsByTagName('h1')[0];
const btn_loader = '<div class="btn-loader"><div class="rect1"></div> <div class="rect2"></div> <div class="rect3"></div> <div class="rect4"></div> <div class="rect5"></div></div>';
const listGroupId = 'list-group';
let href = url.href;
let estabId = '';

const { site, is_mobile_device } = window.tg

if ( h1 !== null && h1 != undefined) {
    // Retrieve data attributes on h1
    estabId = h1.getAttribute('data-estab-id');
}
let shareModal = {};
let bottomTray = null

function shareFallback(type, url) {
    if (site == 'vy') {
        bottomTray = document.getElementById('js-bottom-tray')
    } else if (site === 'ls' && is_mobile_device) {
       bottomTray = document.getElementById("js-bottom-tray");
    } else {
        shareModal = new bsn.default.Modal('#js-modal');
    }

    const params = {
        url: url,
        content_type: type
    };

    let backendURL = type == "results" ? "/backend/results/generate_share_results_link" : `/backend/cms/generate_share_link`;

    axios({
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        method: 'post',
        url: backendURL,
        data: stringify(params)
    }).then(function (response) {
        if (response.data.success) {
            href = response.data.data.url;
            generate_modal_contents();
        }
    });
}

function generate_modal_contents() {
    // Modal/tray areas
    let title
    let body

    if (bottomTray != null) {
        title = null;
        body = bottomTray.querySelector('.tray-body .tray-content-wrapper');
    } else {
        title = document.querySelector('.modal-title');
        body = document.querySelector('.modal-body');
    }

    // Generate content areas
    const listGroup = document.createElement('div');
    listGroup.classList.add('list-group');
    listGroup.id = listGroupId;

    let facebookBtn = document.createElement('button');
    facebookBtn.classList.add("list-group-item","border-0","list-group-item-action","js-share-facebook");
    facebookBtn.innerHTML = '<i class="fab fa-facebook mr-3 fa-fw"></i>' + _t('kd.estab.facebook','Facebook');

    let emailBtn = null;
    if (estabId) {
        emailBtn = document.createElement('button');
        emailBtn.classList.add("list-group-item", "border-0", "list-group-item-action", "js-share-email");
        emailBtn.innerHTML = '<i class="fal fa-envelope mr-3 fa-fw"></i>' + _t('kd.estab.email_to_friend', 'Email to friend');
    }

    let copyBtn = document.createElement('button');
    copyBtn.classList.add("list-group-item","border-0","list-group-item-action","js-share-copy-link");
    copyBtn.innerHTML = '<i class="fal fa-copy mr-3 fa-fw"></i>' + _t('kd.estab.copy_link','Copy link');

    if (bottomTray != null) {
        copyBtn.classList.add('px-0', 'pt-0')
        facebookBtn.classList.add('px-0')
    }

    // Append elements in order
    if (bottomTray == null && emailBtn !== null) {
        listGroup.appendChild(emailBtn);
    }
    listGroup.appendChild(copyBtn);
    listGroup.appendChild(facebookBtn);

    // Change areas
    if (title != null) {
        title.innerHTML = _t('kd.estab.share_via','Share via');
    }
    body.innerHTML = "";
    body.appendChild(listGroup);

    attachListeners(listGroup);

    // Display modal
    if (bottomTray != null) {
        window.Alpine.store('general').updateOpenTray('share', 'Share via', 0, false, 30)
    } else {
        shareModal.show();
    }
}

/**
 * @param {HTMLDivElement} group
 */
function attachListeners(group) {
    Array.prototype.forEach.call(group.children, /** @type {HTMLButtonElement} */ (button) => {

        button.addEventListener('click', function (e) {
            e.preventDefault();

            if (button.classList.contains('js-share-facebook')) {
                facebook();
            } else if (button.classList.contains('js-share-email')) {
                shareEmail();
            // } else if (button.classList.contains('js-share-copy-link')) {
            } else if (button.classList.contains('js-share-copy-link')) {
                copyLink(button);
            } else if (button.classList.contains('js-share-send-self')) {
                sendToSelf(button);
            }
        });

    });
}
/**
 *
 * Copies current href to customers device
 * @param {HTMLButtonElement} button
 */
function copyLink(button) {
    // Create dummy input to copy link value from
    const input_dummy = document.createElement('input');
    document.body.appendChild(input_dummy);
    input_dummy.value = href;
    input_dummy.select();
    document.execCommand('copy');
    document.body.removeChild(input_dummy);
    // Replace to give customer confirmation that it worked and disable it
    button.innerHTML = '<i class="fal fa-check mr-3"></i>' + _t('kd.estab.link_copied','Link copied');
    button.disabled = true;
}

function sendToSelf(button) {
    const params = {
        estab_id: estabId
    };

    axios({
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        method: 'post',
        url: "/backend/accommodation/share_send_to_self",
        data: stringify(params)
    }).then(function (response) {
        const data = response.data;

        if (data.success === true) {
            button.innerHTML = '<i class="fal fa-check mr-3"></i>' + _t('kd.estab.sent_to_you','Sent to you');
            button.disabled = true;
        } else {
            showFormAlert(listGroupId, data.status , data.data.reason);
        }
    });
}

function shareEmail() {

    const params = {
        estabId: estabId
    };

    const body = document.querySelector('.modal-body');

    axios({
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        method: 'post',
        url: "/backend/accommodation/get_share_email_template",
        data: stringify(params)
    }).then(function (response) {
        const data = response.data;
        if (data.success === true) {

            body.innerHTML = data.data.template

            cloudflare_turnstile('estab_email_share');

            setTimeout( function(){
                const inputs = document.querySelectorAll("#js-modal input, #js-modal textarea, #js-modal select")
                for (let i = 0; i < inputs.length; ++i) {
                    let input = /** @type {HTMLInputElement} */ (inputs.item(i))

                    input.addEventListener("change", validationEventListener ,false);
                    input.addEventListener("focusout", validationEventListener ,false);
                }
            }, 100);
        } else {
            showFormAlert(listGroupId, data.status , data.data.reason);
        }
    });
}

function facebook() {
    const fb_href = 'http://www.facebook.com/share.php?u=' + href;
    window.open(fb_href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
}

// Basic option forms request
document.addEventListener("submit", function(event) {
    // Capture the form element
    const formEl = /** @type {HTMLFormElement} */ (event.target);

    const allowedForms = 'js-share-email-friend-form';

    if (allowedForms === formEl.id ) {
        event.preventDefault();
        const submitEl = /** @type {HTMLButtonElement} */ (formEl.querySelectorAll('button[type="submit"]')[0]);
        const submitElInnerHTML = submitEl.innerHTML;
        submitEl.style.width = (Math.ceil(submitEl.offsetWidth) + 1) + 'px'; // 2 for borders
        submitEl.disabled = true;
        submitEl.innerHTML = btn_loader;


        let validate = handleFormSubmit(formEl);

        if (validate) {
            // Check if form has post url
            try {

                if (formEl.action === '') {
                    throw "Form action is empty";
                }
                // Get elements from form
                let formParam = formParams(formEl);

                formParam += `&estab_id=${estabId}`;

                toggleFormInputs(formEl, true);

                axios({
                    headers: {
                        "Content-Type" : "application/x-www-form-urlencoded"
                    },
                    method: 'post',
                    url: formEl.action,
                    data: formParam
                })
                    .then(function (response) {
                        const data = response.data;
                        // Timeout for user to perceive action as loading
                        setTimeout(function () {

                            let reason = '';

                            if (data.data && data.data.reason) {
                                reason = data.data.reason;
                            }

                            if (data.success === true) {
                                showFormAlert(formEl.id, data.status, reason);
                                formEl.classList.add('d-none');

                                setTimeout(function () {
                                    shareModal.hide();
                                }, 5000); // close modal after 5 seconds

                            } else {
                                showFormAlert(formEl.id,data.status, reason);
                                submitEl.innerHTML = submitElInnerHTML;
                                submitEl.disabled = false;
                            }
                        },1000)
                        toggleFormInputs(formEl, false);
                    })

            } catch(e) {
                toggleFormInputs(formEl, false);
                submitEl.innerHTML = submitElInnerHTML;
                submitEl.disabled = false;
            }
        } else {
            toggleFormInputs(formEl, false);
            submitEl.innerHTML = submitElInnerHTML;
            submitEl.disabled = false;
        }
    }
},false);


export {shareFallback};
